module.exports = __webpack_public_path__ + "img/SL7_4606-Bearbeitet.2a568c06.jpg";